// extracted by mini-css-extract-plugin
export default {"cls1":"FacebookDisabledPage-cls1_YPA","cls2":"FacebookDisabledPage-cls2_hsg FacebookDisabledPage-cls1_YPA","show":"FacebookDisabledPage-show_xHz"};